import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  to?: string;
  state?: any;
}

function BackButton({ to, state }: BackButtonProps) {
  const [isHover, setIsHover] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to, { state });
    } else {
      navigate(-1); // default fallback
    }
  };

  return (
    <div className="sticky top-0 bg-white z-49 px-2 py-2 w-full">
      <div
        className="flex flex-row items-center justify-start gap-2 cursor-pointer hover:text-[#961e38] transition-all"
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        onClick={handleClick}
      >
        {isHover ? (
          <FaArrowLeftLong color="#961e38" />
        ) : (
          <FaArrowLeft color="#961e38" />
        )}{" "}
        {t("Back")}
      </div>
    </div>
  );
}

export default BackButton;
